export const replaceTranslate = (translation, ...params) => {
    if (params && params.length) {
        for (let index = 0; index < params.length; index++) {
            translation = translation.replaceAll(`{${index}}`, params[index]);
        }
    }

    return translation;
};
